import { css } from 'lit';

export const AllInResponsiveTable = (superClass) => class extends superClass {
    static properties = {
        _tables: {type: Array, state:true},
        _styles: {type: Array, state:true},
    };

    get tables() {
        return this.renderRoot.querySelectorAll('table');
    }

    updated(){
        this.tables.forEach(table => {
            if(this._tables?.includes(table)){
                return;
            }
            this._makeTableResponsive(table);
        });
    }

    _makeTableResponsive(table){
        try{
            const thArray = [];
            const ths = table.querySelectorAll('th');
            ths.forEach(th=>{
                thArray.push(th.innerText.trim());
            });
            let style = [];
            thArray.forEach((thContent,index)=>{
                style.push(`#${table.id} td:nth-child(${index + 1})::before {content:"${thContent}: ";}`);
            });
            if(!this._styles){
                this._styles = [];
            }
            this._styles = [...this._styles,...style];
            if(!this._tables){
                this._tables = [];
            }
            this._tables = [...this._tables, table];
        }
        catch(error){
            console.error('Error making table responsive:', error);
        }
    }

    static styles = [
        css`
        .scroll-auto{
            overflow: auto;
        }

        table {
            border-collapse: collapse;
        }

        th, td {
            padding: 1rem 1.25rem;
        }

        th{
            background-color: #D3C9D7;
        }

        tr:nth-child(even) {
            background-color: #E8E8E8;
        }

        tr:nth-child(odd) {
            background-color: #F5F2F2;
        }

        td::before {
            display: none;
        }
        @media screen and (max-width: 1000px) {
            .scroll-auto{
                overflow: none;
            }

            table, tr, td{
                display: block;

            }   
            tr{
                padding: 1rem 1.25rem;
            }  
            th, tr:first-of-type{
                display: none;
            }
            td::before {
                display: inline;
                font-weight: bold;
            }
            td:nth-of-type(2)::before {
                font-style: normal;
            }
            
            tr{
                flex-basis: calc(50% - 4rem);
                
            }

            tr:nth-child(n) {
                background-color: #E8E8E8;
            }



            tbody{
                display:grid;
                grid-template-columns: 1fr 1fr;
                gap:1.5rem;
            }
        }

        @media screen and (max-width: 700px) {
            tbody{
                grid-template-columns: 1fr;
            }
        }
        `
    ];
}